import PropTypes from 'prop-types';

export default PropTypes.shape({
  primary: PropTypes.string,
  slug: PropTypes.string,
  short: PropTypes.string,
});
